import React from 'react'
import { useState, useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './PointGrantRule.css'
import { useTranslation } from "react-i18next";

/**
 * ポイント付与ルール設定: 付与種別（本人確認完了・誕生日など）ごとの付与ptと有効/停止。
 * 付与の可否（認証済みか・誕生日か・二重付与でないか）は user 側 API が判定する。
 */
const PointGrantRule = () => {
  const { t } = useTranslation();

  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) xsrfToken = xsrfToken.split('=')[1];
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) token = token.split('=')[1];
    return {
      'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
      'Bearer': decodeURIComponent(token),
      'Content-Type': 'application/json'
    };
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/point-grant-rules`, {
      headers: getAuthHeaders(), credentials: 'include', method: 'GET'
    })
      .then(r => r.json())
      .then(data => setRules((data && data.rules) || []))
      .catch(e => console.error(e));
  }, []);

  const updateRule = (grantType, patch) => {
    setRules(rules.map(rule => rule.grant_type === grantType ? { ...rule, ...patch } : rule));
  };

  const save = () => {
    if (rules.some(rule => rule.point === '' || !Number.isInteger(Number(rule.point)) || Number(rule.point) < 0)) {
      alert(t('point_grant_rule.invalid'));
      return;
    }
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/point-grant-rules`, {
      headers: getAuthHeaders(), credentials: 'include', method: 'POST',
      body: JSON.stringify({
        rules: rules.map(rule => ({ grant_type: rule.grant_type, point: Number(rule.point), is_enabled: rule.is_enabled }))
      })
    })
      .then(r => r.json())
      .then(data => {
        setLoading(false);
        if (data && data.rules) {
          setRules(data.rules);
          alert(t('point_grant_rule.saved'));
        } else {
          alert((data && data.message) || t('common.error'));
        }
      })
      .catch(e => { setLoading(false); console.error(e); alert(t('common.error')); });
  };

  return (
    <>
      <Header />
      <SideMenu />
      <div className="point-grant-rule">
        <div className="point-grant-rule-title">{t('point_grant_rule.title')}</div>
        <div className="clearfix"></div>

        <table className="point-grant-rule-table">
          <thead>
            <tr>
              <th>{t('point_grant_rule.type')}</th>
              <th>{t('point_grant_rule.point')}</th>
              <th>{t('point_grant_rule.enabled')}</th>
            </tr>
          </thead>
          <tbody>
            {rules.map(rule => (
              <tr key={rule.grant_type}>
                <td>{t('point_grant_rule.types.' + rule.grant_type, rule.label)}</td>
                <td>
                  <input
                    className="point-grant-rule-input"
                    type="number"
                    min="0"
                    step="1"
                    value={rule.point}
                    onChange={e => updateRule(rule.grant_type, { point: e.target.value })}
                  /> pt
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={!!rule.is_enabled}
                    onChange={e => updateRule(rule.grant_type, { is_enabled: e.target.checked })}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="point-grant-rule-note">{t('point_grant_rule.note')}</div>

        <button className="point-grant-rule-button-save" onClick={save} disabled={loading}>{t('point_grant_rule.save')}</button>
      </div>
    </>
  )
}

export default PointGrantRule
